export const pxToRem = (px: number): number => parseFloat((px / 16).toFixed(4));

export const toRem = (px: number): string => `${pxToRem(px)}rem`;

export const percent = (min: number, max: number, value: number): number =>
	((value - min) / (max - min)) * 100;
